<template>
  <b-button v-if="isSeriesExist" variant="rounded" @click.stop.prevent="$emit('showModal')">
    Show Waveform
    <Icon name="graph" />
  </b-button>
  <b-button v-else variant="rounded" class="d-flex py-2" @click.stop.prevent="$emit('getWaveform')">
    {{ message }}
    <LoaderAnimation v-if="isLoading" />
    <Icon v-else name="graph" />
  </b-button>
</template>

<script>
import LoaderAnimation from '@/components/shared/loader-animation';

export default {
  name: 'FaultFetchWaveformButton',
  components: { LoaderAnimation },
  props: { isSeriesExist: Boolean, isLoading: Boolean },
  data() {
    return {
      hasBeenFetched: false
    };
  },
  computed: {
    message() {
      return this.hasBeenFetched ? 'Try again' : 'Fetch Waveform';
    }
  },
  created() {
    this.unwatchIsLoadingProp = this.$watch('isLoading', newVal => {
      if (newVal) {
        this.hasBeenFetched = true;

        this.unwatchIsLoadingProp();
      }
    });
  }
};
</script>
